module.exports = __webpack_public_path__ + "static/15-5e076a4c5075d561f88f9b8589e28319.png";